'use strict';
define([], function() {
    function AccessController($scope, $rootScope, LanguageService, $mdMedia, $state, $stateParams, PlanDetailsService, ReviewsService) {
        var vm = $scope;
        vm.switchLang = switchLang;
        vm.$mdMedia = $mdMedia;
        vm.isOnboardingFlow = isOnboardingFlow;
        vm.onboardingStep = onboardingStep;

        $scope.redirectTo = $stateParams.redirectTo;
        $scope.workspaceId = $stateParams.workspaceId;
        $scope.triggerSrc = $stateParams.triggerSrc;
        $scope.accessStateName = $state.current.name;
        $scope.onboardingStepOverride = null;
        $scope.onboardingReviewCategory = null;

        var backgroundReviews = ReviewsService.getShowcaseAll();
        vm.reviewBackgroundColumns = [0, 5, 10].map(function (offset) {
            var column = [];
            for (var index = 0; index < 5; index++) {
                column.push(backgroundReviews[(index + offset) % backgroundReviews.length]);
            }
            return column;
        });

        // Set Language and Country get from Storage or set from default config
        vm.selectedLang = LanguageService.getCodeAndCountrySaveOnStorage();

        vm.isPromoTime = PlanDetailsService.isPromoTime() && PlanDetailsService.getCurrentPromo().promoType == 'all-platform-promo';

        if (vm.isPromoTime) {
            vm.classModifier = PlanDetailsService.getCurrentPromo().currentPromoModifierClass;
        }

        $scope.$on('$stateChangeSuccess', function (event, toState) {
            $scope.accessStateName = toState.name;
            $scope.onboardingStepOverride = null;
        });

        $scope.$on('onboardingStepChanged', function (event, step) {
            $scope.onboardingStepOverride = Number(step) || null;
        });

        $scope.$on('onboardingReviewCategoryChanged', function (event, category) {
            $scope.onboardingReviewCategory = category || null;
        });

        function isOnboardingFlow() {
            return [
                'access.signup',
                'access.email-verification',
                'access.tailor-made'
            ].indexOf($scope.accessStateName) !== -1;
        }

        function onboardingStep() {
            var steps = {
                'access.signup': 1,
                'access.email-verification': 2,
                'access.tailor-made': 3
            };
            return $scope.onboardingStepOverride || steps[$scope.accessStateName] || 1;
        }

        function switchLang(language) {
            vm.selectedLang = language;
            $rootScope.setLang(language);
        }

    }
    AccessController.$inject=['$scope', '$rootScope', 'LanguageService', '$mdMedia', '$state', '$stateParams', 'PlanDetailsService', 'ReviewsService'];
    return AccessController;
});
